import request from '@/utils/request'

// 获取列表顶部的统计数据
export function getStatistics(data) {
	return request({
		url: '/Customer/getStatistics',
		method: 'post',
		data
	})
}
// 获取客户列表
export function getCustomerList(data) {
	return request({
		url: '/Customer/getCustomerList',
		method: 'post',
		data
	})
}
// 导出客户
export function exportCustomer(data) {
	return request({
		url: '/Customer/exportCustomer',
		method: 'post',
		responseType: 'blob',
		data
	})
}

// 添加客户
export function addCustomer(data) {
	return request({
		url: '/Customer/addCustomer',
		method: 'post',
		data
	})
}

// 删除客户
export function deleteCustomer(data) {
	return request({
		url: '/Customer/deleteCustomer',
		method: 'post',
		data
	})
}

// 编辑客户
export function editCustomer(data) {
	return request({
		url: '/Customer/editCustomer',
		method: 'post',
		data
	})
}

// 查看客户
export function checkCustomer(data) {
	return request({
		url: '/Customer/checkCustomer',
		method: 'post',
		data
	})
}
// 编辑客户评级
export function changeLevel(data) {
	return request({
		url: '/Customer/changeLevel',
		method: 'post',
		data
	})
}
// 转为意向客户
export function turnToIntention(data) {
	return request({
		url: '/Customer/turnToIntention',
		method: 'post',
		data
	})
}

// 转为意向客户 24.02.05
export function customerToIntention(data) {
	return request({
		url: '/Customer/customerToIntention',
		method: 'post',
		data
	})
}

// 获取客户资料
export function getFilesData(data) {
	return request({
		url: '/Customer/getFilesData',
		method: 'post',
		data
	})
}
// 获取沟通进度
export function getMessageList(data) {
	return request({
		url: '/Customer/getMessageList',
		method: 'post',
		data
	})
}
// 新增沟通记录
export function addMessage(data) {
	return request({
		url: '/Customer/addMessage',
		method: 'post',
		data
	})
}
// 领取客户
export function receiveCustomer(data) {
	return request({
		url: '/Customer/receiveCustomer',
		method: 'post',
		data
	})
}
// 分配客户
export function distributeCustomer(data) {
	return request({
		url: '/Customer/distributeCustomer',
		method: 'post',
		data
	})
}
// 发送经营资料
export function sendFraData(data) {
	return request({
		url: '/Customer/sendFraData',
		method: 'post',
		data
	})
}
// 发送经营资料
export function getCooperationProgress(data) {
	return request({
		url: '/Customer/getCooperationProgress',
		method: 'post',
		data
	})
}

// 导出客户数据
export function exportWord(data) {
	return request({
		url: '/Customer/exportWord',
		method: 'post',
		data
	})
}

// 查看意向合同
export function checkIntention(data) {
	return request({
		url: '/Customer/checkIntention',
		method: 'post',
		data
	})
}

// 查看正式意向合同
export function checkFranchise(data) {
	return request({
		url: '/Customer/checkFranchise',
		method: 'post',
		data
	})
}

// 查看店铺选址
export function checkSelectAddress(data) {
	return request({
		url: '/Enterprise/Customer/getSelectAddress',
		method: 'post',
		data
	})
}

// 根据省市区查询地图
export function getSpots(data) {
	return request({
		url: '/Customer/getSpots',
		method: 'post',
		data
	})
}

// 根据营业店铺和意向店铺坐标
export function getLocations(data) {
	return request({
		url: '/Enterprise/Customer/getLocation',
		method: 'post',
		data
	})
}

// 意向企业-店铺添加地址
export function addAddress(data) {
	return request({
		url: '/Enterprise/Customer/addAddress',
		method: 'post',
		data
	})
}

//添加悬坠时候的上传合同文件生成pdf
export function uploadSelectFile(data) {
	return request({
		url: '/Enterprise/Customer/uploadSelectLocationFile',
		method: 'post',
		data
	})
}

// 意向企业-改变地址状态
export function changeAddress(data) {
	return request({
		url: '/Enterprise/Customer/changeAddress',
		method: 'post',
		data
	})
}

// 添加加盟客户
export function addJoinCustomer(data) {
	return request({
		url: '/Customer/addJoinCustomer',
		method: 'post',
		data
	})
}

// 客户访问小程序统计图
export function getAppletStatistics(data) {
	return request({
		url: '/Enterprise/Customer/getAppletStatistics',
		method: 'post',
		data
	})
}

// 添加加盟客户
export function importCustomers(data) {
	return request({
		url: '/Customer/importCustomers',
		method: 'post',
		data
	})
}

// 获取企业加盟列表
export function getJoinList(data) {
	return request({
		url: '/Enterprise/Customer/getJoinList',
		method: 'post',
		data
	})
}
// 获取企业加盟列表 V2
export function getJoinListV2(data) {
	return request({
		url: '/V2/Enterprise/Customer/getJoinList',
		method: 'post',
		data
	})
}

// 获取流程列表
export function getProcessList(data) {
	return request({
		url: '/CustomerProcess/getProcessList',
		method: 'post',
		data
	})
}

// 获取流程列表 24.02.05
export function getCustomerIntentionList(data) {
	return request({
		url: '/Customer/getCustomerIntentionList',
		method: 'post',
		data
	})
}

// 获取店铺列表 24.02.05
export function getShopListByphone(data) {
	return request({
		url: '/Customer/getShopListByphone',
		method: 'post',
		data
	})
}

// 绑定店铺 24.02.05
export function bindShop(data) {
	return request({
		url: '/Customer/bindShop',
		method: 'post',
		data
	})
}

// 获取流程日志
export function getProcessLog(data) {
	return request({
		url: '/CustomerProcess/getProcessLog',
		method: 'post',
		data
	})
}

// 获取签约人主体信息
export function getSignerMessage(data) {
	return request({
		url: '/CustomerProcess/getSignerMessage',
		method: 'post',
		data
	})
}

export function test(data) {
	return request({
		url: '/CustomerProcess/test',
		method: 'post',
		data
	})
}

export function getLocation(data) {
	return request({
		url: '/Enterprise/Customer/getLocation',
		method: 'post',
		data
	})
}

export function uploadIntentionFile(data) {
	return request({
		url: '/Customer/uploadIntentionFile',
		method: 'post',
		data
	})
}
// 上传特许经营资料
export function uploadFranchiseFile(data) {
	return request({
		url: '/Customer/uploadFranchiseFile',
		method: 'post',
		data
	})
}

export function newGetCustomerList(data) {
	return request({
		url: '/Public/getCustomerList',
		method: 'post',
		data
	})
}
// 获取绑定店铺列表
export function getShopInfo(data) {
	return request({
		url: '/Enterprise/Customer/getShopInfo',
		method: 'post',
		data
	})
}
// 获取绑定店铺列表 V2
export function getShopInfoV2(data) {
	return request({
		url: '/V2/Enterprise/Customer/getShopInfo',
		method: 'post',
		data
	})
}
// 绑定店铺
export function saveShopInfo(data) {
	return request({
		url: '/Enterprise/Customer/saveShopInfo',
		method: 'post',
		data
	})
}
// 绑定店铺 V2
export function saveShopInfoV2(data) {
	return request({
		url: '/V2/Enterprise/Customer/saveShopInfo',
		method: 'post',
		data
	})
}
// 获取可选择加盟的公司列表
export function getJoinCompany(data) {
	return request({
		url: '/Customer/getJoinCompany',
		method: 'post',
		data
	})
}
//新增转为加盟
export function joinIn(data) {
	return request({
		url: '/CustomerProcess/transToJoin',
		method: 'post',
		data
	})
}

// 新增终止流程
export function stopProcess(data) {
	return request({
		url: '/CustomerProcess/stopProcess',
		method: 'post',
		data
	})
}
// 获取流程进度状态
export function getProcessState(data) {
	return request({
		url: '/CustomerProcess/getProcessState',
		method: 'post',
		data
	})
}

// 获取用户加盟申请信息
export function getApplicationData(data) {
	return request({
		url: '/Customer/getApplicationData',
		method: 'post',
		data
	})
}

// 获取顾问服务申请列表
export function getCustomerServiceList(data) {
	return request({
		url: '/Customer/getCustomerServiceList',
		method: 'post',
		data
	})
}
// 获取用户加盟申请信息
export function getCustomerServiceInfo(data) {
	return request({
		url: '/Customer/getCustomerServiceInfo',
		method: 'post',
		data
	})
}

// 获取顾问服务申请 修改
export function getCustomerServiceEdit(data) {
	return request({
		url: '/Customer/getCustomerServiceEdit',
		method: 'post',
		data
	})
}

// 获取获取首页数据
export function getIndexDataList(data) {
	return request({
		url: '/Customer/getIndexDataList',
		method: 'post',
		data
	})
}

// e-获取签约列表
export function getSignList(data) {
	return request({
		url: '/CustomerProcess/getSignList',
		method: 'post',
		data
	})
}

//跟进-添加记录
export function addFollow(data) {
	return request({
		url: '/Customer/addFollow',
		method: 'post',
		data
	})
}
//跟进-获取跟进列表
export function getFollowList(data) {
	return request({
		url: '/Customer/getFollowList',
		method: 'post',
		data
	})
}
// 跟进-导出跟进记录
export function exportFollow(data) {
	return request({
		url: '/Customer/exportFollow',
		method: 'post',
		data
	})
}

// 跟进-获取导航栏检索列表
export function getNavList(data) {
	return request({
		url: '/Customer/getNavList',
		method: 'post',
		data
	})
}

// 跟进-首页大列表
export function getFollowIndexList(data) {
	return request({
		url: '/Customer/getFollowIndexList',
		method: 'post',
		data
	})
}

// 聊天中是否存在消息【消息提醒】
export function chetRemind(data) {
	return request({
		url: '/Customer/chetRemind',
		method: 'post',
		data
	})
}
